import clientFactory from "../factories/http_client";
import {API} from "../api/api";

class EventLinkService {

	/** @return  Promise<AxiosResponse<T>> */
	create = (projectId, futureMapId, eventId, link) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.event_maps.id.events.id.links.create.method,
			                             url: API.data.projects.id.event_maps.id.events.id.links.create.url(projectId, futureMapId, eventId),
			                             data: API.data.projects.id.event_maps.id.events.id.links.create.build(link),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	save = (projectId, futureMapId, eventId, link) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.event_maps.id.events.id.links.save.method,
			                             url: API.data.projects.id.event_maps.id.events.id.links.save.url(projectId, futureMapId, eventId),
			                             data: API.data.projects.id.event_maps.id.events.id.links.save.build(link),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	delete = (projectId, futureMapId, eventId, linkId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.event_maps.id.events.id.links.delete.method,
			                             url: API.data.projects.id.event_maps.id.events.id.links.delete.url(projectId, futureMapId, eventId),
			                             data: API.data.projects.id.event_maps.id.events.id.links.delete.build(linkId),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	get = (projectId, futureMapId, eventId, linkId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.event_maps.id.events.id.links.id.method,
			                             url: API.data.projects.id.event_maps.id.events.id.links.id.url(projectId, futureMapId, eventId, linkId),
		                             });
	};
}

export default EventLinkService